import { checkEwalletExpiryDateChange } from 'components/FormEditReceiver/func';
import {
  EDIT_RECEIVER_FISTNAME_NAME,
  EDIT_RECEIVER_GENDER_NAME,
  EDIT_RECEIVER_LASTNAME_NAME,
  EDIT_RECEIVER_MOBILE_NAME,
  EDIT_RECEIVER_PHONE_NAME,
  EDIT_RECEIVER_POSTAL_NAME,
  EDIT_RECEIVER_RELATIONSHIP_NAME,
  EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME,
  EDIT_RECEIVER_STATE_NAME,
  EDIT_RECEIVER_STREET_NAME,
  EDIT_RECEIVER_SUBURB_NAME,
} from 'constants';
import useStore from 'hooks/useStore';
import { isEmpty } from 'lodash';

const useUpdateReceiverStore = () => {
  const { state, setState } = useStore();
  const { editReceiverInformation, editReceiverCurrentStep, currentReceiver } =
    state || {};
  const { personalDetails, residentialAddress, accountDetails } =
    editReceiverInformation || {};

  const {
    firstName,
    lastName,
    gender,
    mobileNumber,
    phoneNumber,
    relationship,
    address,
    banks,
    ewallets,
  } = currentReceiver || {};
  const { street, city, suburb, postcode } = address || {};

  const receiverFirstNameStore = personalDetails?.[EDIT_RECEIVER_FISTNAME_NAME];
  const receiverLastNameStore = personalDetails?.[EDIT_RECEIVER_LASTNAME_NAME];
  const receiverTypeStore =
    personalDetails?.[EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME];
  const receiverGenderStore = personalDetails?.[EDIT_RECEIVER_GENDER_NAME];
  const receiverMobileStore = personalDetails?.[EDIT_RECEIVER_MOBILE_NAME];
  const receiverPhoneStore = personalDetails?.[EDIT_RECEIVER_PHONE_NAME];
  const receiverRelationshipStore =
    personalDetails?.[EDIT_RECEIVER_RELATIONSHIP_NAME];
  const receiverAddressStore = residentialAddress?.[EDIT_RECEIVER_STREET_NAME];
  const receiverStateStore = residentialAddress?.[EDIT_RECEIVER_STATE_NAME];
  const receiverDistricStore = residentialAddress?.[EDIT_RECEIVER_SUBURB_NAME];
  const receiverPostalCodeStore =
    residentialAddress?.[EDIT_RECEIVER_POSTAL_NAME];
  const receiverBanksStore = accountDetails?.banks;
  const receiverEwalletsStore = accountDetails?.ewallets;

  const isPersonalDetailsNameChanged =
    (receiverFirstNameStore &&
      receiverFirstNameStore?.toUpperCase() !== firstName?.toUpperCase()) ||
    (receiverLastNameStore &&
      receiverLastNameStore?.toUpperCase() !== lastName?.toUpperCase());
  const isPersonalDetailsGenderChanged =
    receiverGenderStore &&
    receiverGenderStore?.toUpperCase() !== gender?.toUpperCase();
  const isPersonalDetailsMobileChanged =
    (!isEmpty(receiverMobileStore) && receiverMobileStore !== mobileNumber) ||
    (receiverTypeStore && receiverMobileStore !== mobileNumber);
  const isPersonalDetailsPhoneChanged =
    (!isEmpty(receiverPhoneStore) && receiverPhoneStore !== phoneNumber) ||
    (receiverTypeStore && receiverPhoneStore !== phoneNumber);
  const isPersonalDetailsRelationshipChanged =
    !isEmpty(receiverRelationshipStore) &&
    receiverRelationshipStore?.key !== relationship;
  const isPersonalDetailsInformationChanged =
    isPersonalDetailsNameChanged ||
    isPersonalDetailsGenderChanged ||
    isPersonalDetailsMobileChanged ||
    isPersonalDetailsPhoneChanged ||
    isPersonalDetailsRelationshipChanged;
  const isPersonalDetailsInformationVerified =
    Boolean(receiverTypeStore) && Boolean(receiverGenderStore);

  const isResidentialAddressStateChanged =
    receiverAddressStore &&
    receiverAddressStore?.toUpperCase() !== street?.toUpperCase();
  const isResidentialAddressDistrictChanged =
    !isEmpty(receiverStateStore) &&
    receiverStateStore?.name?.toUpperCase() !== city?.name?.toUpperCase();
  const isResidentialAddressSuburbChanged =
    !isEmpty(receiverDistricStore) &&
    receiverDistricStore?.name?.toUpperCase() !== suburb?.name?.toUpperCase();
  const isResidentialAddressPostalCodeChanged =
    receiverPostalCodeStore && receiverPostalCodeStore !== postcode;
  const isResidentialAddressInformationChanged =
    isResidentialAddressStateChanged ||
    isResidentialAddressDistrictChanged ||
    isResidentialAddressSuburbChanged ||
    isResidentialAddressPostalCodeChanged;

  const checkAccountDetailsBanksChange = (receiverBanksStore) => {
    const rootBanks = banks;
    const otherBanks = receiverBanksStore;

    if (rootBanks?.length !== otherBanks?.length) return true;

    for (let i = 0; i < rootBanks?.length; i++) {
      if (
        otherBanks[i]?.bankName !== rootBanks[i]?.bankName ||
        otherBanks[i]?.accountName !== rootBanks[i]?.accountName ||
        otherBanks[i]?.accountNumber !== rootBanks[i]?.accountNumber ||
        otherBanks[i]?.swiftCode !== rootBanks[i]?.swiftCode ||
        otherBanks[i]?.branchCode !== rootBanks[i]?.branchCode
      )
        return true;
    }

    return false;
  };
  const checkAccountDetailsEwalletsChange = (receiverEwalletsStore) => {
    const rootEwallets = ewallets;
    const otherEwallets = receiverEwalletsStore;

    if (rootEwallets?.length !== otherEwallets?.length) return true;

    for (let i = 0; i < rootEwallets?.length; i++) {
      if (
        otherEwallets[i]?.ewalletProviderName !==
          rootEwallets[i]?.ewalletProviderName ||
        otherEwallets[i]?.ewalletNumber !== rootEwallets[i]?.ewalletNumber ||
        checkEwalletExpiryDateChange(
          otherEwallets[i]?.expiryDate,
          rootEwallets[i]?.expiryDate,
        )
      )
        return true;
    }

    return false;
  };
  const isAccountDetailsBanksChanged =
    !isEmpty(receiverBanksStore) &&
    checkAccountDetailsBanksChange(receiverBanksStore);
  const isAccountDetailsEwalletsChanged =
    !isEmpty(receiverEwalletsStore) &&
    checkAccountDetailsEwalletsChange(receiverEwalletsStore);
  const isAccountDetailsInformationChanged =
    isAccountDetailsBanksChanged || isAccountDetailsEwalletsChanged;

  return {
    ...state,
    editReceiverInformation,
    editReceiverCurrentStep,

    receiverTypeStore,
    receiverGenderStore,

    isPersonalDetailsNameChanged,
    isPersonalDetailsGenderChanged,
    isPersonalDetailsMobileChanged,
    isPersonalDetailsPhoneChanged,
    isPersonalDetailsRelationshipChanged,
    isPersonalDetailsInformationChanged,
    isPersonalDetailsInformationVerified,

    isResidentialAddressStateChanged,
    isResidentialAddressDistrictChanged,
    isResidentialAddressSuburbChanged,
    isResidentialAddressPostalCodeChanged,
    isResidentialAddressInformationChanged,

    checkAccountDetailsBanksChange,
    isAccountDetailsBanksChanged,
    checkAccountDetailsEwalletsChange,
    isAccountDetailsEwalletsChanged,
    isAccountDetailsInformationChanged,
  };
};

export default useUpdateReceiverStore;
